<template>
  <nav class="navbar user-top-nav" v-if="getToken">
    <div class="container-fluid">
      <header class="align-items-center d-flex w-100 head">
        <!-- burger -->
        <span class="toggle" @click="$emit('toggled')">
          <div class="l1"></div>
          <div class="l1"></div>
          <div class="l1"></div>
        </span>
        <!-- Page Title Goes Here -->
        <div class="page-title" :class="showHideClass">
          <!--    <breadcrumbs /> -->
        </div>
        <!-- End of page title -->
        <!-- Action Buttons Mobile Only 
        <a
          class="ml-auto action"
          data-toggle="collapse"
          href="#collapseSearch"
          role="button"
          aria-expanded="false"
          aria-controls="collapseExample"
        >
        
        </a>-->
        <!-- End Action Buttons Mobile only -->
        <!-- Search is hidden until later version of JobShark 
        <form class="form-inline">
          <div class="input-group user-search">
            <input
              type="text"
              class="form-control"
              name="search"
              placeholder="Search"
              aria-describedby="search"
            />
            <i class="fas fa-search" aria-hidden="true"></i>
          </div>
        </form>
        End of Search-->

        <div v-if="canSeeMixin(['manager', 'user'])" class="buttons holder">
          <button
            v-if="
              getManagerUserProfile.employer_freelancers === 2 ||
                getManagerUserProfile.employer_freelancers === 3
            "
            type="button"
            class="btn btn-success text-nowrap mr-2"
            :class="
              getGuide.show && getGuide.step === 3
                ? 'animate__animated animate__headShake animate__infinite	animate__slow'
                : ''
            "
            @click="showModalFreeLancer = true"
          >
            Find Freelancers
            <portal to="add-job-modal-freelancer">
              <CustomMainModal
                @close="onCloseAddManagerJobModalFreeLancer"
                v-show="showModalFreeLancer"
              >
                <template v-slot:header>
                  <h5>Find Freelancers</h5>
                </template>
                <AddManagerFreeLancerBtnModal
                  :userProfile="getManagerUserProfile"
                  v-if="showModalFreeLancer"
                />
              </CustomMainModal>
            </portal>
          </button>

          <button
            type="button"
            class="btn btn-success text-nowrap"
            :class="[
              getManagerUserProfile.employer_freelancers !== 1 ? '' : 'ms-auto',
              getGuide.show && getGuide.step === 3
                ? 'animate__animated animate__headShake animate__infinite animate__slow'
                : '',
            ]"
            @click="showModal = true"
          >
            Post a Job
            <portal to="add-job-modal">
              <CustomMainModal @close="onCloseAddManagerJobModal" v-show="showModal">
                <template v-slot:header>
                  <h5>{{ modalTitle }}</h5>
                </template>
                <AddManagerJobBtnModal
                  :userProfile="getManagerUserProfile"
                  v-if="showModal"
                  @step="changeHeader($event)"
                />
              </CustomMainModal>
            </portal>
          </button>
          <portal-target name="add-job-modal"></portal-target>
          <portal-target name="add-job-modal-freelancer"></portal-target>
          <div
            v-if="getGuide.show === true && getGuide.step === 3"
            class="guide-box animate__animated animate__fadeIn animate__faster"
          >
            <span>Get started</span>
            <img src="https://jobshark.eu/img/2.jpeg" alt="jobshark candidates" />
            <p>
              You start your journey here by either requesting freelancers or posting a job for
              direct hiring.
            </p>
            <div class="buttons">
              <button @click="closeGuide" class="btn btn-primary">Got it - I’m ready!</button>
            </div>
          </div>
        </div>

        <div
          class="notifications mt-1 ml-2"
          tabindex="0"
          @blur="closeNotification"
          ref="bell"
          style="outline: none;"
        >
          <router-link to>
            <i @click="openNotification('bell')" class="far fa-bell"></i>
            <span class="badge badge-light"></span>
          </router-link>

          <transition name="fade">
            <!--  <div v-show="toggleNotifications" class="wrapper">
              <div class="triangle"></div>
              <h6>Notifications</h6>
              <ul class="list-unstyled">
                <li>
                  <h5 class="text-center">Notifications are empty</h5>
                </li>
                <li>
                  <span class="time">YY-MM-DD hh:mm</span>
                  <p>
                    <a href="#">[User]</a>, <a href="#">[Employer]</a> posted a note for
                    <a href="#">[Candidate]</a>,
                    <a href="#">[Job]</a>
                    <a href="#">[City]</a>
                  </p>

                  <span class="note">
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                    incididunt ut labore et dolore magna aliqua.
                  </span>
                </li>

                <li>
                  <span class="time">YY-MM-DD hh:mm</span>
                  <p>
                    <a href="#">[Candidate]</a> is <span style="color: #5bb75b">hired</span> for the
                    position as
                    <a href="#">[Job]</a>
                    <a href="#">[City]</a>
                    by
                    <a href="#">[Employer]</a>
                  </p>
                </li>

                <li>
                  <span class="time">YY-MM-DD hh:mm</span>
                  <p>
                    The ad for the position as
                    <a href="#">[Job]</a>
                    <a href="#">[City]</a>
                    for
                    <a href="#">[Employer]</a>
                    has been
                    <span style="color: #5bb75b">approved.</span>
                  </p>
                </li>

                <li>
                  <span class="time">YY-MM-DD hh:mm</span>
                  <p>
                    The job posting for the position as
                    <a href="#">[Job]</a>
                    <a href="#">[City]</a>
                    for
                    <a href="#">[Employer]</a>
                    <span style="color: #f02800">has expired</span>
                  </p>
                </li>

                <li>
                  <span class="time">YY-MM-DD hh:mm</span>
                  <p>
                    New candidate:
                    <a href="#">[Candidate]</a>
                    has been submitted to the position as
                    <a href="#">[Job]</a>
                    <a href="#">[City]</a>
                  </p>
                </li>

                <li>
                  <span class="time">YY-MM-DD hh:mm</span>
                  <p>
                    New opportunity: There is a new job as
                    <a href="#">[Job]</a>
                    for
                    <a href="#">[Employer]</a>,
                    <a href="#">[City]</a>
                    that may interest you
                  </p>
                </li>
              </ul>
            </div> -->
          </transition>
        </div>
        <!-- End Notifications -->

        <div class="dropdown show user-settings" style="z-index: 100 !important">
          <a
            class="btn btn-outline dropdown-toggle"
            href="#"
            role="button"
            id="dropdownMenuLink"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            >{{ profile.first_name || profile.name }}</a
          >

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <ul class="list-unstyled">
              <span class="triangle"></span>

              <!--    <li v-if="getAccType == this.userType('candidate')">
                <router-link class="dropdown-item" :to="{ name: 'user-profile' }">
                  <i class="fas fa-user"></i> <span>My Profile</span></router-link
                >
              </li>
 -->
              <!--   <li v-if="getAccType != this.userType('manager')">
                <router-link class="dropdown-item" :to="{ name: 'manager-profile' }">
                  <i class="fas fa-user"></i> <span>My Profile</span></router-link
                >
              </li> -->
              <!-- <li v-if="getAccType == this.userType('admin')">
                <router-link class="dropdown-item" :to="{ name: 'manager-profile' }"
                  ><i class="fas fa-user"></i> <span>My Profile</span></router-link
                >
              </li> -->
              <!-- Email templates will be added at later version of Jobshark 
            <a class="dropdown-item" href="#">Email Templates</a>-->
              <!-- Career portal will be added at later version of Jobshark 
            <a class="dropdown-item" href="#">Career portal</a>-->
              <!-- User Management is only available to Admins and Employers -->
              <li v-if="canSeeMixin(['admin'])">
                <router-link class="dropdown-item" :to="{ name: 'competences' }"
                  ><i class="fas fa-server"></i> <span>Competencies</span></router-link
                >
              </li>

              <li v-if="canSeeMixin(['admin'])">
                <router-link class="dropdown-item" :to="{ name: 'sources' }"
                  ><i class="fas fa-server"></i> <span>Sources</span></router-link
                >
              </li>

              <li v-if="canSeeMixin(['admin'])">
                <router-link class="dropdown-item" :to="{ name: 'zones' }"
                  ><i class="fas fa-clock"></i> <span>Time zones</span></router-link
                >
              </li>

              <li v-if="canSeeMixin(['admin'])">
                <router-link class="dropdown-item" :to="{ name: 'campaigns' }"
                  ><i class="fas fa-newspaper"></i> <span>Campaigns </span></router-link
                >
              </li>

              <li v-if="canSeeMixin(['admin'])">
                <router-link class="dropdown-item" :to="{ name: 'price-plans' }"
                  ><i class="fas fa-euro-sign"></i> <span>Price plans </span></router-link
                >
              </li>
              <li v-if="canSeeMixin(['admin'])">
                <router-link class="dropdown-item" :to="{ name: 'engagement' }"
                  ><i class="fas fa-chart-bar"></i> <span>Engagement</span></router-link
                >
              </li>

              <li v-if="canSeeMixin(['admin'])">
                <router-link class="dropdown-item" :to="{ name: 'website' }"
                  ><i class="fas fa-newspaper"></i> <span>Website</span></router-link
                >
              </li>

              <li v-if="canSeeMixin(['admin'])">
                <router-link class="dropdown-item" :to="{ name: 'aimodels' }"
                  ><i class="fas fa-newspaper"></i> <span>AI models</span></router-link
                >
              </li>

              <li
                v-if="
                  canSeeMixin(['manager', 'candidate', 'admin', 'recruiter', 'user', 'marketing'])
                "
              >
                <router-link
                  class="dropdown-item"
                  :to="{
                    name: getSettings,
                  }"
                  ><i class="fas fa-cog"></i> <span>Settings</span></router-link
                >
              </li>

              <li v-if="canSeeMixin(['admin', 'manager'])">
                <router-link
                  class="dropdown-item"
                  :to="{
                    name: getAccType == 'manager' ? 'manager-user-managment' : 'user-managment',
                  }"
                  ><i class="fas fa-users"></i> <span>User management</span></router-link
                >
              </li>
              <li v-if="canSeeMixin(['admin'])">
                <router-link class="dropdown-item" :to="{ name: 'logs' }"
                  ><i class="far fa-address-book"></i> <span>Logs</span></router-link
                >
              </li>
              <li v-if="canSeeMixin(['manager', 'user'])">
                <router-link class="dropdown-item" :to="{ name: 'manager-support' }"
                  ><i class="far fa-question-circle"></i> <span>Support</span></router-link
                >
              </li>
              <li v-if="canSeeMixin(['candidate'])">
                <router-link class="dropdown-item" :to="{ name: 'candidate-support' }"
                  ><i class="far fa-question-circle"></i> <span>Support</span></router-link
                >
              </li>
              <li>
                <a @click="logout" href="#" class="dropdown-item"
                  ><i class="fas fa-sign-out-alt"></i> <span>Sign Out</span></a
                >
              </li>
            </ul>
          </div>
        </div>
        <router-link to class="user-avatar">
          <img :src="avatar" alt="profile picture" />
        </router-link>
      </header>
    </div>
  </nav>
</template>

<script>
import { canSeeMixin } from '../../mixins/canSeeMixin';
import { userRoleMixin } from '../../mixins/userRoleMixin';
import AddManagerJobBtnModal from '../Manager/Jobs/AddManagerJobBtnModal.vue';
import AddManagerFreeLancerBtnModal from '../Manager/Jobs/AddManagerFreeLancerBtnModal.vue';
import CustomMainModal from '../Modals/CustomMainModal.vue';
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';

export default {
  /* props: ['toggler'], */
  mixins: [userRoleMixin, canSeeMixin],
  components: {
    AddManagerJobBtnModal,
    AddManagerFreeLancerBtnModal,
    CustomMainModal,
  },
  data: () => ({
    toggleNotifications: false,
    bindClass: false,
    avatar: '',
    showModal: false,
    showModalFreeLancer: false,
    modalTitle: 'Post a Job - Choose Recruitment Plan',
  }),
  props: {
    toggler: {
      type: Boolean,
    },
    profile: {
      type: Object,
    },
    avatarProp: {
      type: String,
    },
    showModalJob: {
      type: String,
    },
  },
  watch: {
    profile: {
      handler(newVal, oldVal) {
        // console.table({ ...newVal });

        if (newVal.photo !== oldVal.photo) {
          this.setAvatar(newVal.photo);
        }
      },
      deep: true,
    },

    showModalJob: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.toggleModals(newVal);
        }
      },
    },
  },
  methods: {
    ...mapActions(['retrieveUserProfile', 'retrieveUserProfileMarketing']),
    ...mapActions('managerStoreModule', ['retrieveManagerUserProfile']),
    onCloseAddManagerJobModal() {
      this.showModal = false;
      this.modalTitle = 'Post a Job - Choose Recruitment Plan';
    },

    closeGuide() {
      this.$store.commit('managerStoreModule/SET_GUIDE_SHOW', false);
      this.hideGuide();
    },

    hideGuide() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/manager/updateguidescreen`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.intro = false;
        });
    },

    toggleModals(modal) {
      if (modal === 'tech') {
        this.showModal = true;
      }
      if (modal === 'free') {
        this.showModalFreeLancer = true;
      }
      this.intro = false;
    },
    onCloseAddManagerJobModalFreeLancer() {
      this.showModalFreeLancer = false;
    },

    changeHeader(ev) {
      if (ev.step === 0) {
        this.modalTitle = 'Post a Job - Choose Recruitment Plan';
      }
      if (ev.step === 0.5) {
        if (ev.plan === 1) {
          this.modalTitle = 'Post a Job - Fee Structure for Sourcing Plan';
        } else {
          this.modalTitle = 'Post a Job - Fee Structure for Full-Service Plan';
        }
      }
      if (ev.step === 1) {
        this.modalTitle = 'Post a Job';
      }
    },

    logout() {
      this.$store
        .dispatch('destroyToken')
        .then(() => {
          this.$router.push('/');
          sessionStorage.removeItem('first');
          this.$toasted.show('You are successfully logged out', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(() => {
          this.$router.push('/');

          this.$toasted.error('You are successfully logged out.', {
            theme: 'bubble',
            icon: 'fa-exclamation-circle',
            position: 'bottom-right',
            duration: 10000,
          });
        });
    },
    setAvatar(photo) {
      if (photo === null || photo === 'default.png' || photo === 'null') {
        this.avatar = 'https://jobshark.eu/img/comstream.svg';
      } else {
        switch (this.getAccType) {
          case 'manager':
            this.avatar = `https://jobshark.eu/storage/employers/avatars/${photo}`;
            return;
          case 'admin':
            this.avatar = `https://jobshark.eu/storage/avatars/${photo}`;
            return;
          case 'candidate':
            this.avatar = `https://jobshark.eu/storage/candidateavatars/${photo}`;
            return;
          case 'user':
            this.avatar = `https://jobshark.eu/storage/employers/avatars/${photo}`;
            return;
          case 'recruiter':
            this.avatar = `https://jobshark.eu/storage/avatars/${photo}`;
            return;
          case 'marketing':
            this.avatar = `https://jobshark.eu/storage/avatars/${photo}`;
            return;
          default:
            return '';
        }
      }
    },
    /*   canSee(roles) {
      try {
        return roles.includes(this.getAccType);
      } catch (err) {
        console.log(err);
      }
    }, */
    /* handleClickOutside(evt) {

      if (evt.target.id != 'bell' && evt.target.id != 'notifications-dropdown') {
        this.toggleNotifications = false;
      }
    }, */
    openNotification(el) {
      this.toggleNotifications = true;
      this.$refs[el].focus();
    },
    closeNotification() {
      this.toggleNotifications = false;
    },
    renewPrice() {
      this.retrieveManagerUserProfile();
    },
  },
  computed: {
    ...mapGetters(['getToken', 'getAccType', 'getUserProfile']),
    ...mapGetters('managerStoreModule', ['getManagerUserProfile', 'getGuide']),
    showHideClass() {
      return this.bindClass ? 'page-title-hide' : 'page-title-show';
    },
    getSettings() {
      switch (this.getAccType) {
        case 'manager':
          return 'manager-settings';
        case 'admin':
          return 'admin-settings';
        case 'candidate':
          return 'candidate-user-settings';
        case 'recruiter':
          return 'recruiter-settings';
        case 'user':
          return 'manager-settings';
        case 'marketing':
          return 'admin-settings';
        default:
          return '';
      }
    },
  },
  created() {
    if (this.$route.name === 'candidate_id') {
      this.bindClass = true;
    }

    if (this.$route.name === 'job_uuid') {
      this.bindClass = true;
    }

    if (this.$route.name === 'employer_id') {
      this.bindClass = true;
    }
  },
  mounted() {
    if (localStorage.getItem('acc') === 'marketing') {
      this.retrieveUserProfileMarketing();
    }
    document.addEventListener('click', this.handleClickOutside);

    if (this.profile.photo) {
      this.setAvatar(this.profile.photo);
    }
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/_mixins';

.head {
  justify-content: right;
  gap: 12px;
}

.holder {
  position: relative;
  .guide-box {
    background-color: #eeeded;
    position: absolute;
    left: -30px;
    top: 50px;
    padding: 20px;
    width: 320px;
    z-index: 9999;
    border: 1px solid #ddd;
    border-radius: 12px;
    box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.2);
    span {
      font-size: 18px;
      display: block;
      font-weight: 600;
      margin-bottom: 15px;
    }
    img {
      max-width: 100%;
      height: auto;
    }
    p {
      font-size: 14px;
    }
    .buttons {
      display: flex;
      gap: 15px;
      .btn {
        flex: 1;
        font-size: 13px;
      }
    }
  }
}

.user-avatar {
  img {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    object-fit: cover;
  }
}
/* TRANSITIONS */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.user-top-nav {
  margin: 25px;
  a.action {
    display: none;
    color: #fff;
    text-decoration: none;
    font-size: 21px;
  }
  .form-inline {
    width: 33%;
  }

  .page-title {
    display: none;
  }
  .toggle {
    position: absolute;
    top: 15px;
    left: 15px;
    width: 36px;
    height: 36px;
    padding: 6px 2px 2px 2px;
    cursor: pointer;
    display: none;

    .l1 {
      height: 3px;
      background: #fff;
      margin-bottom: 6px;
      &:first-of-type {
        width: 100%;
        height: 3.2px;
      }
      &:nth-of-type(2) {
        width: 66%;
      }
      &:nth-of-type(3) {
        width: 33%;
      }
    }
  }
}

.user-search {
  position: relative;
  width: 100%;
  input {
    display: block;
    width: 100%;
    height: 35px;
    border: 0;
    background: #333333 0% 0% no-repeat padding-box;
    border-radius: 15px !important;
    opacity: 1;
    color: $color-white;
    padding-top: 8px;

    &::placeholder {
      color: #e6e3e3;
      font-size: 0.8rem;
    }

    &:focus {
      color: $color-white;
      background-color: #333;
    }
  }

  .fa-search {
    position: absolute;
    right: 1.1rem;
    top: 6px;
    font-size: 21px;
    /* color: $color-white; */
    color: #e6e3e3;
    z-index: 999;
  }
}

.user-settings {
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -2px;
    width: 1px;
    height: 15px;
    background: #fff;
    transform: translate(0, -50%);
  }

  .btn-outline {
    box-shadow: none !important;
  }
}

.dropdown-menu {
  left: -100% !important;
}

.notifications {
  position: relative;
  i {
    color: $color-white;
    font-size: 19px;
    height: 1.2rem;
    width: auto;

    &:hover,
    &:active {
      color: $custom-checkbox-color;
    }
  }

  .badge {
    background: $custom-checkbox-color;
    color: #fff;
    position: absolute;
    top: -12px;
    right: -10px;
    border-radius: 50%;
  }

  .dropdown {
    a::after {
      content: none;
    }
  }

  .wrapper {
    background: #ffffff;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    box-shadow: 0px 2px 10px #00000027;
    font-family: $font-family-sans-lato;
    position: absolute;
    top: 46px;
    right: -64px;
    width: 460px;
    z-index: 9;

    h6 {
      border-bottom: 1px solid #ddd;
      padding: 18px 0 21px 0;
      color: #4d4f5c;
      font-size: 17px;
      text-align: center;
      margin: 0;
    }

    .list-unstyled {
      margin: 0 2px 3px 0;
      padding: 6px 33px;
      max-height: calc(100vh - 200px);
      overflow-y: auto;

      li {
        border-bottom: 1px solid #ccc;
        padding: 15px 0 20px 0;

        span.time {
          color: $color-black;
          display: block;
          font-size: 12px;
          margin-bottom: 5px;
        }

        p {
          color: $color-card-title;
          display: block;
          font-size: 14px;
          margin: 0;
        }

        a {
          text-decoration: none;
          font-size: 14px;
        }
        .note {
          color: $btn-default-color;
          font-size: 13px;
        }
      }
    }

    .triangle {
      position: absolute;
      bottom: 99%;
      right: 65px;
      width: 14px;
      height: 14px;
      background: #fff;
      clip-path: polygon(0 0, 100% 100%, 0 100%);
      transform: rotate(135deg);
    }
    @include orange-scrollbar;
  }
}
/* end notification window */

.dropdown-menu {
  padding: 0;
  border-radius: 6px;
  border: 0;
  margin-top: 0px;
  box-shadow: 0px 2px 10px #00000027;
  top: 50px;
  width: 240px;

  .triangle {
    display: block;
    height: 14px;
    width: 14px;
    border: inherit;
    background: inherit;
    position: absolute;
    top: -6px;
    right: 9px;
    clip-path: polygon(0 0, 100% 100%, 0 100%);
    transform: rotate(135deg);
  }

  .dropdown-item {
    color: #4d565c;
    font-family: $font-family-sans-lato;
    font-size: 15px;
    padding: 0.5rem;
  }

  .dropdown-item:not(:last-child) {
    border-bottom: 1px solid rgba(204, 204, 204, 0.404) !important;
    padding: 0.5rem;
  }
  .list-unstyled {
    margin-bottom: 0;
    li {
      border-bottom: 1px dashed #ccc;
      padding: 6px 12px;
      i {
        display: inline-block;
        width: 25px;
        margin-right: 5px;
        color: #ccc;
      }
      &:last-of-type {
        border: none;
      }
    }
  }
}

/* Media queries */

@media only screen and (max-width: 1251px) {
  .page-title-hide {
    display: none !important;
  }
  .user-top-nav {
    margin: 0;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 62px;
    border-radius: 0;
    z-index: 9999;
    .toggle {
      display: block;
      margin-right: 5px;
    }
    .form-inline {
      width: 50%;
    }
    .page-title {
      display: block;
      color: #fff;
      font-size: 20px;
      font-weight: 700;
    }
  }
}

@media only screen and (max-width: 992px) {
  .holder {
    position: relative;
    .guide-box {
      background-color: #eeeded;
      position: absolute;
      left: -90px;
      top: 50px;
      padding: 20px;
      width: 320px;
      z-index: 9999;
      border: 1px solid #ddd;
      border-radius: 12px;
      box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.2);
      span {
        font-size: 18px;
        display: block;
        font-weight: 600;
        margin-bottom: 15px;
      }
      img {
        max-width: 100%;
        height: auto;
      }
      p {
        font-size: 14px;
      }
      .buttons {
        display: flex;
        gap: 15px;
        .btn {
          flex: 1;
          font-size: 13px;
        }
      }
    }
  }
  .page-title-hide {
    display: none !important;
  }
  .user-top-nav {
    margin: 0;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 62px;
    border-radius: 0;
    z-index: 9999;
    .toggle {
      display: block;
      margin-right: 5px;
    }
    .form-inline {
      width: 50%;
    }
    .page-title {
      display: block;
      color: #fff;
      font-size: 20px;
      font-weight: 700;
    }
  }
}

@media only screen and (max-width: 768px) {
  .page-title-hide {
    display: none !important;
  }
  .user-top-nav {
    margin: 0;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 62px;
    border-radius: 0;
    z-index: 9999;
    .toggle {
      display: block;
      margin-right: 5px;
    }
    .form-inline {
      width: 44%;
    }
    .page-title {
      display: block;
      color: #fff;
      font-size: 20px;
      font-weight: 700;
    }
  }
}

@media only screen and (max-width: 576px) {
  .page-title-hide {
    display: block !important;
  }
  .user-top-nav {
    margin: 0;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 62px;
    border-radius: 0;
    z-index: 9999;
    a.action {
      display: block;
    }
    .toggle {
      display: block;
    }
    .page-title {
      display: block;
      color: #fff;
      font-size: 20px;
      font-weight: 700;
    }

    .form-inline {
      display: none;
    }
    .notifications {
      display: none;
    }
    .user-settings {
      display: none;
    }
    .user-avatar {
      display: none;
    }
  }
}
</style>
